import PropTypes from "prop-types";
import React from "react";
import DebouncedTextField from "../common/DebouncedTextField";
import FiltersBar from "../common/FiltersBar";

const UserFilters = ({ filter, updateFilter, ...rest }) => (
  <FiltersBar {...rest}>
    <DebouncedTextField
      value={filter.textSearch || ""}
      onChange={(text) => updateFilter("textSearch", text)}
      placeholder="Type to filter"
    />
  </FiltersBar>
);

UserFilters.propTypes = {
  filter: PropTypes.object.isRequired,
  updateFilter: PropTypes.func.isRequired,
};

export default UserFilters;
